//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SliceNames } from '@redux/SliceNames';

interface ISyndicationInsights {
  emptyStateReason?: string;
}

const initialState: ISyndicationInsights = {
  emptyStateReason: undefined,
};

const { reducer, actions } = createSlice({
  name: SliceNames.SyndicationInsights,
  initialState,
  reducers: {
    setEmtpyStateReason: (state, action: PayloadAction<string>) => {
      state.emptyStateReason = action.payload;
    },
  },
});

export const syndicationInsightsActions = actions;

export default reducer;
